/** @jsx  */
import React from 'react';
import {
  SymbolSize20,
  SymbolSize30,
  SymbolSize40,
  SymbolSize60,
  SymbolSize80,
  SymbolSize120,
  SymbolSize150,
} from './svgs';

type Props = {
  /**
   * The size of the Logo
   */
  size?: 20 | 30 | 40 | 60 | 80 | 120 | 150;
};

const getLogo = (size: Props['size']) => {
  switch (size) {
    case 20:
      return <SymbolSize20 />;
    case 30:
      return <SymbolSize30 />;
    case 40:
      return <SymbolSize40 />;
    case 60:
      return <SymbolSize60 />;
    case 80:
      return <SymbolSize80 />;
    case 120:
      return <SymbolSize120 />;
    case 150:
      return <SymbolSize150 />;
    default:
      return <SymbolSize40 />;
  }
};

/**
 * Symbol variant of the Zapier Logo
 */
export const ZapierLogoSymbol = ({ size = 40 }: Props) => {
  return getLogo(size);
};
